import * as React from "react";
import {Forms} from "./Forms";
let ReactDOM = require("react-dom");
import 'shared/styles/bootstrap.scss';
import './Bootstrap.css';
import {WpAjaxPost} from "shared/core/ajax/WPAjaxPost";

WpAjaxPost.SetGlobalVar(formsVar);

ReactDOM.render(<Forms/>,document.getElementById('App'));